import ConfirmLeaveModal from '@src/ui/templates/Shared/ConfirmLeaveModal';
import React from 'react';

const ConfirmMemberInvitationLeaveModal: React.FC<{
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}> = ({ isOpen, onConfirm, onClose }) => {
  return (
    <ConfirmLeaveModal
      isOpen={isOpen}
      title='まだ招待されていません。'
      message={
        <p className='text-sm leading-[1.6]'>
          選択された参加者は、まだチャンネルに招待されていません。このまま続行すると、選択結果が破棄されますがよろしいですか？
        </p>
      }
      confirmText='招待情報を破棄して閉じる'
      cancelText='招待を続行'
      onConfirm={onConfirm}
      onClose={onClose}
      width='500px'
    />
  );
};

export { ConfirmMemberInvitationLeaveModal };
